// @flow

import 'i18n';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

import {AppContainer} from 'container/AppContainer';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

// Create a root
const root = createRoot(container);

// Initial render: Render the AppContainer to the root
root.render(
  <StrictMode>
    <AppContainer />
  </StrictMode>
);
